import { render } from "./LesHabitues.vue?vue&type=template&id=b396fec8&scoped=true&ts=true"
import script from "./LesHabitues.vue?vue&type=script&lang=ts"
export * from "./LesHabitues.vue?vue&type=script&lang=ts"

import "./LesHabitues.vue?vue&type=style&index=0&id=b396fec8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b396fec8"]])

export default __exports__